import React, { memo, useEffect, useMemo, useState } from "react";
import { Card, Button, Space, Typography, Tag, Tooltip } from "antd";
import { GiftOutlined, RightOutlined, CloseOutlined } from "@ant-design/icons";

const { Text } = Typography;

const PromotionFooterWidget = ({
  visible,
  displayName,
  isWeekend,
  onCreatePromotion,
  defaultExpanded = false,     // you can control initial state if needed
  autoExpandOnWeekend = false, // optional: set true if you want weekend auto-open once
}) => {
  const name = useMemo(() => {
    const n = String(displayName || "").trim();
    return n || "there";
  }, [displayName]);

  const [expanded, setExpanded] = useState(!!defaultExpanded);

  // Optional: auto expand once on weekend (per session)
  useEffect(() => {
    if (!visible) return;
    if (!autoExpandOnWeekend) return;
    if (!isWeekend) return;

    try {
      const key = "hms.promoFooter.autoExpanded.v1";
      if (sessionStorage.getItem(key) === "1") return;
      sessionStorage.setItem(key, "1");
      setExpanded(true);
    } catch {
      setExpanded(true);
    }
  }, [visible, autoExpandOnWeekend, isWeekend]);

  if (!visible) return null;

  // Collapsed floating button
  if (!expanded) {
    return (
      <div
        style={{
          position: "fixed",
          right: 16,
          bottom: 16,
          zIndex: 1000,
        }}
      >
        <Tooltip title={isWeekend ? "Weekend Special" : "Create Promotion"} placement="left">
          <Button
            type="primary"
            shape="circle"
            size="large"
            icon={<GiftOutlined />}
            onClick={() => setExpanded(true)}
            style={{
              width: 52,
              height: 52,
              boxShadow: "0 10px 28px rgba(0,0,0,0.18)",
            }}
            aria-label="Open promotions"
          />
        </Tooltip>
      </div>
    );
  }

  // Expanded card
  return (
    <div
      style={{
        position: "fixed",
        right: 16,
        bottom: 16,
        zIndex: 1000,
        width: 320,
        maxWidth: "calc(100vw - 32px)",
      }}
    >
      <Card
        size="small"
        styles={{ body: { padding: 12 } }}
        style={{ borderRadius: 12, boxShadow: "0 10px 28px rgba(0,0,0,0.18)" }}
      >
        <Space direction="vertical" size={8} style={{ width: "100%" }}>
          <Space style={{ justifyContent: "space-between", width: "100%" }} align="center">
            <Space align="center">
              <GiftOutlined />
              <Text strong>Promotions</Text>
            </Space>

            <Space size={6} align="center">
              {isWeekend ? <Tag color="green">Weekend</Tag> : <Tag>Anytime</Tag>}
              <Button
                type="text"
                size="small"
                icon={<CloseOutlined />}
                onClick={() => setExpanded(false)}
                aria-label="Close promotions widget"
              />
            </Space>
          </Space>

          <Text type="secondary" style={{ fontSize: 12 }}>
            Hello {name}. Create a quick promo and share it with your guest list.
          </Text>

          <Button
            type="primary"
            block
            onClick={() => {
              setExpanded(false);
              onCreatePromotion?.();
            }}
          >
            Create Promotion <RightOutlined />
          </Button>

          <Button type="link" block onClick={() => setExpanded(false)}>
            Not now
          </Button>
        </Space>
      </Card>
    </div>
  );
};

export default memo(PromotionFooterWidget);
